import ReactOnRails from 'react-on-rails';

import BookSSR from '../bundles/book/BookSSR';
import '../../../packages/ui/src/styles.scss';
// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  BookSSR,
} as any)
